import { GuidGenerator } from './../../../BaseFramework/core/utilities/commonUtility';
import { MetadataService } from './../../../BaseFramework/core/http/metadata.service';
import { AgentService } from './../../../BaseFramework/core/http/agent.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
    ValidationUtilService,
    ApiRequestService,
    CommonUtilty,
    I18nService,
    MultiLingualService,
    InteractService,
    ClientService,
    ComponentOutputDO,
    AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { take } from 'rxjs/operators';
import { PolicyAgentDO } from './../../../FunctionalModules/PolicyIssuance/models/policyAgent.model';
import { Observable, forkJoin, zip } from 'rxjs';

class SearchAPIMetaDataDO {
    key: any;
    keyDescription: any;
    valueInputType: any;
    lookupName: any;
    lookup: any;
    enable: true;
    isMandatory: Boolean;
}


@Component({
    selector: 'app-agent-search',
    templateUrl: './agent-search.component.html',
    styleUrls: ['./agent-search.component.scss']
})
export class AgentSearchComponent implements OnInit {
    _currentComponentName = 'AgentSearchComponent'
    constructor(
        private viewContainerRef: ViewContainerRef,
        private validationUtilService: ValidationUtilService,
        private apiRequestService: ApiRequestService,
        private fb: FormBuilder,
        private commonUtilty: CommonUtilty,
        private i18nService: I18nService,
        private multiLingualService: MultiLingualService,
        private translateService: TranslateService,
        private interactService: InteractService,
        private clientService: ClientService,
        public appMetadataHandler: AppMetadataHandler,
        private agentService: AgentService,
        private metadataService: MetadataService
    ) { }

    //Declaraions
    currentPage: any = 0;
    itemsPerPage: any = 20;
    searchObservable
    selectedAgent: any;
    agentDataSet = [];
    public CRITERIALOOKUP = [];
    selectedAgentList = [];

    public agentZeroState = {
        title: "Search Required",
        message: "Hit search to view results",
        icon: "file-search"
    }

    pingSubject$
    ngOnInit() {
        this.multiLingualService.setLanguageForLazyLoadedComponents(this.translateService)
        var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
        if (environment && !environment.production) {
            console.group('%Agent Policy Search : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
            console.log("%c<app-agent-search'></app-agent-search'>, has been used. ", consoleStyle)
            console.log("%cYou can override following attributes -----------------------------------", consoleStyle)
            console.log("%cExample , <app-agent-search></app-agent-search'>", consoleStyle)
            console.groupEnd();
        }

        if (this.pingSubject$ != null) this.pingSubject$.unsubscribe();
        this.pingSubject$ = this.interactService.pingAgentSubject$.subscribe(value => {
            if (value)
                this.emitSelectedAgents();
        })


        this.getAgentSearchCriteriaList();
        this.subscribeToParentEvent()

    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
    }

    /**
     * ComponentSpecific Inputs, Outputs and Functions
     *  
     */
    @Output() componentOutput = new EventEmitter<any>();
    @Input() title: string = "No Data";
    @Input() clientRole: string;
    EmitComponentOutput(data) {
        let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
        console.log("agent search emiited data to generic component", c);
    }
    getParentComponent(): Component {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
        } catch { }
    }
    getParentComponentName(): string {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
        } catch { }
    }
    getCurrentComponentName(): string {
        return this._currentComponentName
    }

    parentEvent$
    subscribeToParentEvent() {
        if (this.parentEvent$ != null)
            this.parentEvent$.unsubscribe()
        this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
            this.EmitComponentOutput(this.getSelectedAgents());
        })
    }
    getAgentSearchCriteriaList() {
        this.metadataService.fetchAPIMetaData('searchAgent')
            .subscribe(jsonResp => {
                if (jsonResp && typeof jsonResp === typeof []) {
                    jsonResp.forEach(criteria => {
                        let searchCriteriaDO = new SearchAPIMetaDataDO();
                        searchCriteriaDO.key = criteria.attributeName;
                        searchCriteriaDO.keyDescription = criteria.description;
                        searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
                        searchCriteriaDO.lookupName = criteria.attributeLookupCd;
                        searchCriteriaDO.lookup = [];
                        searchCriteriaDO.enable = true;
                        searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
                        this.CRITERIALOOKUP.push(searchCriteriaDO)
                    })
                }
            })
    }

    convertToSearchRequestPayload(formObject) {
        console.log(formObject)
        var payload = {}
        payload["page"] = this.currentPage
        payload["size"] = this.itemsPerPage || 10
        payload["searchCriteriaList"] = []

        var attributes = JSON.parse(JSON.stringify(Object.keys(formObject)));

        attributes.forEach(key => {
            var criteriaItem = {}
            criteriaItem["paramName"] = key
            criteriaItem["paramValue"] = formObject[key];
            payload["searchCriteriaList"].push(criteriaItem)
        });

        return payload
    }

    convertToSearchRequestPayloadPolicy(guid) {
        var payload = {}
        payload["page"] = this.currentPage
        payload["size"] = this.itemsPerPage || 10
        payload["searchCriteriaList"] = []

        var criteriaItem = {}
        criteriaItem["paramName"] = "guid"
        criteriaItem["paramValue"] = guid;
        payload["searchCriteriaList"].push(criteriaItem)
        return payload
    }

    getSelectedAgents() {
        return this.agentDataSet.filter(d => d.selected)
    }

    emitSelectedAgents() {
        let selectedAgents = this.getSelectedAgents();
        console.log("selectedAgents", JSON.stringify(selectedAgents));
        let proposalAgents = [];
        if (Array.isArray(selectedAgents) && selectedAgents.length > 0) {
            selectedAgents.forEach(agentDO => {
                let policyAgentDO = new PolicyAgentDO();
                policyAgentDO.id = null;
                policyAgentDO.guid = new GuidGenerator().setGuid();
                policyAgentDO.agentNum = agentDO.agentNum;
                policyAgentDO.primaryFl = null;
                policyAgentDO.firstName = agentDO.firstName;
                policyAgentDO.lastName = agentDO.lastName;
                policyAgentDO.companyContactUserId = agentDO.companyContactUserId;
                policyAgentDO.clientId = agentDO.clientId;
                policyAgentDO.channelCd = agentDO.channelCd;
                policyAgentDO.companyCd = agentDO.companyCd;
                policyAgentDO.subChannelCd = agentDO.subChannelCd;
                policyAgentDO.partnerbranchCd = agentDO.partnerbranchCd;
                policyAgentDO.vatApplicableFl = agentDO.vatApplicableFl;
                policyAgentDO.companyBranchCd = agentDO.companyBranchCd;
                policyAgentDO.commissionPercent = 0;
                proposalAgents.push(policyAgentDO);
            })
        }

        // this.EmitComponentOutput(selectedPolicies)
        this.fetchClientDOforSelectAgent(proposalAgents)
    }

    agentClientDOSubscription$;
    fetchClientDOforSelectAgent(data) {
        console.log("agent role in client search", this.clientRole);
        let agentNumList = [];
        if (Array.isArray(data) && data.length > 0) {
            data.forEach(agentObj => {
                if (agentObj.agentNum) {
                    agentNumList.push(agentObj.agentNum);
                }
            })
        }

        let agentObservables = [];
        for (let agentNum of agentNumList) {
            agentObservables.push(this.agentService.getAgentByAgentNum(agentNum))
        }

        if (this.agentClientDOSubscription$ != null) this.agentClientDOSubscription$.unsubscribe();

        this.agentClientDOSubscription$ = zip(...agentObservables).subscribe(res => {
            console.log("zip responses", JSON.stringify(res));
            if (Array.isArray(res) && res.length > 0) {
                let responses = [];
                res.forEach(arrayObj => {
                    if (Array.isArray(arrayObj) && arrayObj.length > 0) {
                        arrayObj.forEach(obj => {
                            responses.push(obj);
                        })
                    }

                })
                console.log("agent responses", JSON.stringify(responses));
                let output = { role: this.clientRole, selectedClientData: data, fetchedClientData: responses }
                let clientList = { role: this.clientRole, clientDO: responses }
                console.log("selected Intermediary details output", JSON.stringify(output));
                this.EmitComponentOutput(output)
                this.interactService.selectedAgentsList(clientList);
            }
        })
        // })



        // let agentResponses = [];
        // data.forEach(agentObj => {
        //     this.agentService.getAgentByAgentNum(agentObj.agentNum)
        //         .subscribe(resp => {
        //             agentResponses.push(resp);
        //             console.log("agent data by num", JSON.stringify(resp));
        //             let output = { role: 'Agent', selectedClientData: [data], fetchedClientData: agentResponses }
        //             console.log("selecte agent details output", JSON.stringify(output));
        //             // this.EmitComponentOutput(output)
        //         },
        //             (error) => {

        //                 throw " Something went wrong";
        //             }
        //         );
        // })
    }

    fetchSearchResult($event) {
        if ($event && !$event.reset) {
            if ($event && $event.results) {
             
                this.agentDataSet = $event.results;
                console.log("agentDataSet", JSON.stringify(this.agentDataSet));
                console.log(this.agentDataSet)
                if (!this.agentDataSet || (this.agentDataSet && this.agentDataSet.length == 0)) {
                    this.agentZeroState.title = "No Results found"
                    this.agentZeroState.message = "No records available for the selected search criteria."
                }

                console.log("agent search data", JSON.stringify(this.agentDataSet));
            }
            else{
                this.agentDataSet = []
            }
        }
        else{
            this.agentDataSet = []
        }
    }
}
